// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import fuzzySort from './fuzzySort';
// eslint-disable-next-line @typescript-eslint/no-var-requires
// const fuzzySort = require('./fuzzySort');

// https://www.npmjs.com/package/fuzzysort
export const Search = (searchString: any, targets: unknown[], options: any) => {
  return fuzzySort.go(searchString, targets, {
    threshold: options.threshold || -Infinity, // Don't return matches worse than this (higher is faster)
    limit: options.limit || 10, // Don't return more results than this (lower is faster)
    all: false, // If true, returns all results for an empty search

    keys: options.keys || null, // For when targets are objects (see its example usage)
    scoreFn: options.scoreFn || null // For use with `keys` (see its example usage)
  });
};
